module.exports = __webpack_public_path__ + "static/img-servo-ten-pack-a1b5a6d0d1c236387168b981f063fb21.jpg";